var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-3"},[_c('h4',[_vm._v("Beispiel")]),_c('blockquote',{staticClass:"lex-entry-example mt-2"},[_c('Content',{staticClass:"exsample-content",attrs:{"slice":_vm.slice}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }